import React from 'react'

const HelpHeader = () => {
  return (
    <div className="flex flex-col mx-auto  my-[50px] lg:my-[4vw] w-[342px] md:w-full lg:w-[33vw]">
    <p className=" text-[30px] lg:text-30 font-bold font-urbanist">
      How Can We Help You?
    </p>
    <p className="text-[18px] lg:text-18 text-[#7a798a]">
    At BidCaribean, we strive to provide a secure, transparent, and simple platform, offering unparalleled value compared to competitors. Let’s see how we stack up:
    </p>
  
  </div>
  )
}

export default HelpHeader